import axios from 'axios'
import config from '@/config'

const actions = {
  GET_APPLICATION_DETAILS({rootGetters}, applicationId) {
    return new Promise((resolve, reject) => {
      axios
        .get(config.APi_URL + 'application/extended/' + applicationId, rootGetters.getRequestConfig)
        .then(response => resolve(response.data))
        .catch(err => reject(err))
    })
  },
  ACCEPT_APPLICATION({rootGetters}, applicationId) {
    return new Promise((resolve, reject) => {
      axios
        .post(
          config.APi_URL + 'application/accept/' + applicationId,
          null,
          rootGetters.getRequestConfig
        )
        .then(response => {
          resolve(response)
        })
        .catch(err => reject(err.response.data))
    })
  },
  CHECK_APPLICATION({rootGetters}, application) {
    return new Promise((resolve, reject) => {
      axios
        .get(
          config.APi_URL +
            'application/check/' +
            '?addressId=' +
            application.addressId +
            '&identificationNumber=' +
            application.identificationNumber +
            '&applicationId=' +
            application.id,
          rootGetters.getRequestConfig
        )
        .then(response => {
          resolve(response)
        })
        .catch(err => reject(err))
    })
  },
  REJECT_APPLICATION({rootGetters}, applicationId) {
    return new Promise((resolve, reject) => {
      axios
        .post(
          config.APi_URL + 'application/reject/' + applicationId,
          null,
          rootGetters.getRequestConfig
        )
        .then(response => {
          resolve(response)
        })
        .catch(err => reject(err))
    })
  },
  REPLACE_APPLICATION({rootGetters}, applicationRequestBody) {
    return new Promise((resolve, reject) => {
      axios
        .post(
          config.APi_URL + 'application/replace',
          applicationRequestBody,
          rootGetters.getRequestConfig
        )
        .then(response => {
          resolve(response)
        })
        .catch(err => reject(err))
    })
  },
  DOWNLOAD_APPLICATION({rootGetters}, {dateFrom, dateTo, isRegistered, status}) {
    let params =
      'application/all/download' +
      '?dateFrom=' +
      dateFrom +
      '&dateTo=' +
      dateTo +
      '&isRegistered=' +
      isRegistered +
      '&status=' +
      status
    return new Promise((resolve, reject) => {
      axios
        .get(config.APi_URL + params, {
          headers: rootGetters.getRequestConfig.headers,
          responseType: 'blob'
        })
        .then(response => {
          resolve(response)
        })
        .catch(err => reject(err))
    })
  }
}

export default {
  namespaced: true,
  actions
}
